import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WidgetInfo } from 'src/app/interfaces/widget-info';
import { WidgetPanelCounts } from 'src/app/interfaces/widget-panel-counts';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-vendor-renewals-widget',
  templateUrl: './vendor-renewals-widget.component.html',
  styleUrls: ['./vendor-renewals-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorRenewalsWidgetComponent {
  constructor(private ToastService: ToastService) {}

  @Input() widgetInfo?: WidgetInfo;

  widgetPanelCounts?: WidgetPanelCounts;

  ngOnInit(): void {
    if (!this.widgetInfo) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing renewing widget data.',
        { returnError: true }
      );
    }

    this.widgetPanelCounts = {
      title: 'Renewing Vendors',
      noDataMessage: 'You do not have any proposals',
      hasData: false,
      data: this.widgetInfo.data as Map<string, number>
    };
  }
}
